"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
var _balanceBatchSend = require("@/api/balanceBatchSend");
var _download = require("@/utils/download");
var _taskDetailPop = _interopRequireDefault(require("./components/taskDetailPop.vue"));
var _addBlance = _interopRequireDefault(require("./components/addBlance.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    taskDetailPop: _taskDetailPop.default,
    addBlance: _addBlance.default
  },
  data: function data() {
    return {
      status: '',
      time: '',
      page: 1,
      size: 10,
      total: 1,
      tableList: []
    };
  },
  watch: {
    time: function time(val) {
      if (val === null) {
        this.time = '';
      }
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    add: function add() {
      this.$refs.addBlance.open({});
    },
    getList: function getList() {
      var _this = this;
      (0, _balanceBatchSend.queryList)({
        page: this.page,
        size: this.size,
        status: this.status,
        startTime: this.time ? this.time[0] : '',
        endTime: this.time ? this.time[1] : ''
      }).then(function (res) {
        _this.total = res.data.total;
        _this.tableList = res.data.data;
      });
    },
    search: function search() {
      this.page = 1;
      this.getList();
    },
    rest: function rest() {
      this.status = '';
      this.time = '';
      this.search();
    },
    down: function down() {
      (0, _download.selfDownload)('/portal/system/balance/downTemplate');
    },
    goDetail: function goDetail(val) {
      this.$refs.taskDetailPop.open({
        id: val.taskId
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getList();
    }
  }
};